import { LOCALE_MAP_TO_I18N_TS } from "constants/lang";
import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import resources from "./resources";
import { getLanguageType } from "./weglot";

const languageType = getLanguageType();
const initialLanguage = LOCALE_MAP_TO_I18N_TS[languageType.value];

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: initialLanguage,
    fallbackLng: "ja",
    debug: process.env.NODE_ENV === "development",
    resources,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
